import { useMutation, UseMutationResult } from "react-query";
import { ApiResponse } from "./types";
import { thirdPartySignInAndUp } from "supertokens-auth-react/recipe/thirdpartyemailpassword";

export default function useOAuthCallback(): UseMutationResult<ApiResponse<any>> {
  return useMutation(["oauth-callback"], () => oauthCallback());
}

async function oauthCallback(): Promise<ApiResponse<any>> {
  let response;
  try {
    response = await thirdPartySignInAndUp({
      options: {
        preAPIHook: async (context) => {
          const plan = localStorage.getItem("initialPlanId");
          const fromPath = localStorage.getItem("fromThirdpartyPath");
          context.requestInit.headers = {
            ...context.requestInit.headers,
            "X-Plan-ID": plan ?? "",
            "X-From-Path": fromPath ?? "",
          };
          return {
            url: context.url,
            requestInit: context.requestInit,
          };
        },
      },
    });
  } catch (err: any) {
    localStorage.removeItem("fromThirdpartyPath");
    if (err.isSuperTokensGeneralError === true) {
      throw err;
    } else {
      throw Object.assign(new Error("Something went wrong. Please try again or reach out to support@tableflow.com if the problem persists."), {
        code: 402,
      });
    }
  }
  localStorage.removeItem("fromThirdpartyPath");
  if (response.status === "OK") {
    if (response.createdNewUser) {
      // Sign up successful
      localStorage.removeItem("initialPlanId");
    } else {
      // Sign in successful
    }
    return {
      ok: true,
      error: "",
      data: response,
    };
  } else {
    throw Object.assign(new Error("No email provided by social login. Please use another form of login"), {
      code: 402,
    });
  }
}
